module.exports = __webpack_public_path__ + "static/img/updateCard.964fe7f4.png";